<template lang="pug">
div
  app-imovel-denominacao(
    :required="false",
    :imovel="cadastro.imovel",
    tipoCadastro="INFORMACOES"
  )
  app-matricula-imovel(
    :imovel="cadastro.imovel"
    :required="false",
  )
  app-imovel-dados-titulo(
    :imovel="cadastro.imovel"
    :required="false",
  )
  app-documentos(
    :maxSize='25',
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="cadastro.imovel.documentos"
    :tiposDocumentos="documentos"
    :observer="observer",
    aba="Imovel"
  )
</template>

<script>
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
import { mapActions } from 'vuex'
import AppImovelDenominacao from '../../../../components/cadastro/AppImovelDenominacao'
import AppImovelDadosTitulo from '../../../../components/cadastro/AppImovelDadosTitulo'
import AppMatriculaImovel from '../../../../components/AppMatriculaImovel'

export default {
  components: {
    AppImovelDenominacao,
    AppMatriculaImovel,
    AppImovelDadosTitulo,
    AppDocumentos
  },

  props: ['cadastro', 'observer'],

  data () {
    return {
      documentos: []

    }
  },

  async beforeRouteLeave (to, from, next) {
    this.documentos = await this.findDocumentos('imovelInformacoes')
    await this.observer.validate({ providerName: 'Imóvel/Documentos', skipIfEmpty: false })
    next()
  },

  async created () {
    this.documentos = await this.findDocumentos('imovelInformacoes')
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    })
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/solicitarInformacao/components/Imovel.vue